export const CareersInquiryMap = {
  GET_ALL_HFDI_CAREERS_INQ_START: "GET_ALL_HFDI_CAREERS_INQ_START",
  GET_ALL_HFDI_CAREERS_INQ_SUCCESS: "GET_ALL_HFDI_CAREERS_INQ_SUCCESS",
  GET_ALL_HFDI_CAREERS_INQ_ERROR: "GET_ALL_HFDI_CAREERS_INQ_ERROR",
  SEARCH_TEXT_CHANGE: "SEARCH_TEXT_CHANGE",
  SET_HFDI_CAREERS_INQ_BATCH_NUMBER: "SET_HFDI_CAREERS_INQ_BATCH_NUMBER",
  GET_HFDI_CAREERS_INQ_START: "GET_HFDI_CAREERS_INQ_START",
  GET_HFDI_CAREERS_INQ_SUCCESS: "GET_HFDI_CAREERS_INQ_SUCCESS",
  GET_HFDI_CAREERS_INQ_ERROR: "GET_HFDI_CAREERS_INQ_ERROR",
  SELECT_HFDI_CAREERS_INQ_DETAILS: "SELECT_HFDI_CAREERS_INQ_DETAILS",
};

export const careersInquiryAction = {
  getAllCareersInquiryStart: (data) => ({
    type: CareersInquiryMap.GET_ALL_HFDI_CAREERS_INQ_START,
    payload: data,
  }),
  getAllCareersInquirySuccess: (data) => ({
    type: CareersInquiryMap.GET_ALL_HFDI_CAREERS_INQ_SUCCESS,
    payload: data,
  }),
  getAllCareersInquiryError: (errors) => ({
    type: CareersInquiryMap.GET_ALL_HFDI_CAREERS_INQ_ERROR,
    payload: { errors },
  }),
  refreshCareersInquiryList: () => ({
    type: CareersInquiryMap.REFRESH_HFDI_CAREERS_INQ_LIST,
  }),
  searchTextChange: (data) => ({
    type: CareersInquiryMap.SEARCH_TEXT_CHANGE,
    payload: data,
  }),
  setCareersInquiryBatchNumber: (data) => ({
    type: CareersInquiryMap.SET_HFDI_CAREERS_INQ_BATCH_NUMBER,
    payload: data,
  }),
  getCareersInquiryStart: (data) => ({
    type: CareersInquiryMap.GET_HFDI_CAREERS_INQ_START,
    payload: data,
  }),
  getCareersInquirySuccess: (data) => ({
    type: CareersInquiryMap.GET_HFDI_CAREERS_INQ_SUCCESS,
    payload: data,
  }),
  getCareersInquiryError: (errors) => ({
    type: CareersInquiryMap.GET_HFDI_CAREERS_INQ_ERROR,
    payload: { errors },
  }),
};
